import { LitElement, html } from 'lit'
import { customElement } from 'lit/decorators.js'
import { TW } from '../shared'

const TwLitElement = TW(LitElement)

/**
 * Container rund um die Entwickler-Tools:
 * 
 * - Grid Indicator
 * - Breakpoint Indicator
 */
@customElement('dev-tools')
export class DevTools extends TwLitElement {

    render() 
    {
        return html`
            <div class="fixed left-2.5 bottom-2.5 z-9999 flex gap-2 items-center">
                <grid-indicator></grid-indicator>
                <breakpoint-indicator></breakpoint-indicator>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'dev-tools': DevTools
    }
}
